/* eslint arrow-body-style: ["error", "always"] */

const { apiHost = '' } = window.chatwootConfig || {};

const endPoints = {
  resetPassword: {
    url: `${apiHost}/auth/password`,
  },
  register: {
    url: `${apiHost}/api/v1/accounts.json`,
  },
  validityCheck: {
    url: `${apiHost}/auth/validate_token`,
  },
  profileUpdate: {
    url: `${apiHost}/api/v1/profile`,
  },
  availabilityUpdate: {
    url: `${apiHost}/api/v1/profile/availability`,
  },
  autoOffline: {
    url: `${apiHost}/api/v1/profile/auto_offline`,
  },
  logout: {
    url: `${apiHost}/auth/sign_out`,
  },

  me: {
    url: `${apiHost}/api/v1/conversations.json`,
    params: { type: 0, page: 1 },
  },

  getInbox: {
    url: `${apiHost}/api/v1/conversations.json`,
    params: { inbox_id: null },
  },

  fetchFacebookPages: {
    url(accountId) {
      return `api/v1/accounts/${accountId}/callbacks/facebook_pages.json`;
    },
    params: { omniauth_token: '' },
  },

  deleteAvatar: {
    url: `${apiHost}/api/v1/profile/avatar`,
  },

  setActiveAccount: {
    url: `${apiHost}/api/v1/profile/set_active_account`,
  },

  resendConfirmation: {
    url: `${apiHost}/api/v1/profile/resend_confirmation`,
  },
};

export default page => {
  return endPoints[page];
};
